var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tri-manager-tab-table"},[_c('base-table',{ref:"baseTable",attrs:{"custom-fetch":_vm.fetchMasterRows_,"columns":_vm.columns_,"ui-pagination":""},scopedSlots:_vm._u([{key:"rowCheckbox",fn:function(ref){
var row = ref.row;
return [_c('b-field',[_c('b-checkbox',{attrs:{"value":_vm.isChecked(row)},on:{"input":function (value) { return _vm.onTableCheck(value, row); }}})],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de0b64e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tri/TriManagerTabTable.vue
// module id = null
// module chunks = 